// extracted by mini-css-extract-plugin
export default {"root":"styles_root__TfUT4","editable":"styles_editable__JHHhC","edit-actions":"styles_edit-actions__VT9w+","editActions":"styles_edit-actions__VT9w+","icon":"styles_icon__mLjR0"};